import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const dialogDescriptionVariants = cva('rocco-dialog-description', {
    variants: {
        variant: {
            default: 'text-sm text-muted-foreground',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DialogDescription = React.forwardRef<
    React.ElementRef<typeof DialogPrimitive.Description>,
    React.ComponentPropsWithoutRef<typeof DialogPrimitive.Description> &
        VariantProps<typeof dialogDescriptionVariants>
>(({ className, variant, ...props }, ref) => (
    <DialogPrimitive.Description
        ref={ref}
        className={cn(dialogDescriptionVariants({ variant, className }))}
        {...props}
    />
));

DialogDescription.displayName = DialogPrimitive.Description.displayName;
